export function updateDiscipleStateSelector(state, id) {
  return state.local.disciples.updating[id]
}
